var __defProp = Object.defineProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
__export(exports, {
  ERROR_MESSAGE: () => ERROR_MESSAGE
});
const ERROR_MESSAGE = {
  invalid_aeat_app_code: "C\xF3digo no v\xE1lido",
  invalid_aeat_app_pin: "Pin no v\xE1lido",
  invalid_aeat_reference_number: "Numero de referencia inv\xE1lido",
  invalid_cadaster_number: "C\xF3digo de cat\xE1stro inv\xE1lido",
  invalid_cif: "CIF no tiene formato v\xE1lido",
  invalid_date: "Fecha inv\xE1lida",
  invalid_decimal: "El n\xFAmero debe de ser decimal",
  invalid_email: "El campo email no tiene un formato correcto",
  invalid_email_validation_code: "C\xF3digo de verificaci\xF3n inv\xE1lido",
  invalid_field: "El campo no tiene un formato correcto",
  invalid_iban: "IBAN no tiene un formato correcto",
  invalid_integer: "El n\xFAmero debe de ser entero",
  invalid_length: "El campo debe de tener {{length}} car\xE1cteres",
  invalid_max: "El campo debe ser menor que {{max}}",
  invalid_max_date: "La fecha deber ser menor que {{max}}",
  invalid_min: "El campo debe ser mayor que {{min}}",
  invalid_min_date: "La fecha deber ser mayor que {{min}}",
  invalid_nie: "NIE no tiene un formato v\xE1lido",
  invalid_nif: "NIF no tiene un formato v\xE1lido",
  invalid_nif_nie: "NIF/NIE no tiene un formato v\xE1lido",
  invalid_nif_nie_cif: "NIF/NIE/CIF no tiene un formato v\xE1lido",
  invalid_nie_support_number: "N\xFAmero de soporte no tiene un formato v\xE1lido",
  invalid_password: "La contrase\xF1a debe incluir un n\xFAmero, una letra may\xFAscula, otra min\xFAscula y tener al menos 6 caracteres",
  invalid_regex: "El campo no tiene un formato v\xE1lido",
  invalid_required: "El campo es obligatorio",
  invalid_singleoption: "Selecciona una opci\xF3n v\xE1lida",
  invalid_text: "El campo es obligatorio",
  invalid_text_length: "El campo debe tener como m\xE1ximo {{length}} car\xE1cteres",
  password_low: "baja",
  password_medium: "media",
  password_strong: "muy buena"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ERROR_MESSAGE
});
